import { ChevronDown, ChevronUp } from 'lucide-react';
import { useState } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: 'Are online casinos legal in the UK?',
      answer: 'Yes, online gambling is fully legal and regulated in the UK. All casinos we recommend hold valid UK Gambling Commission licenses, ensuring they meet strict standards for fairness, security, and responsible gambling.',
    },
    {
      question: 'How do I claim a welcome bonus?',
      answer: 'Most welcome bonuses activate automatically when you make your first deposit. Some require a bonus code – we always include these in our offer details. Make sure to check wagering requirements before claiming, as these determine how many times you need to bet before withdrawing winnings.',
    },
    {
      question: 'What are wagering requirements?',
      answer: 'Wagering requirements (also called playthrough requirements) tell you how many times you must bet your bonus amount before you can withdraw winnings. For example, a £100 bonus with 30x wagering means you need to bet £3,000 total. Lower is better – we highlight casinos with the fairest terms.',
    },
    {
      question: 'How quickly can I withdraw my winnings?',
      answer: 'Withdrawal times vary by casino and payment method. E-wallets like PayPal and Skrill typically process in 24-48 hours, while bank transfers can take 3-5 business days. We test and verify payout speeds for every casino we review.',
    },
    {
      question: 'Is my personal information safe?',
      answer: 'All licensed UK casinos use advanced encryption (SSL) to protect your data. They\'re also required to comply with GDPR and data protection laws. We only recommend casinos with proven security track records.',
    },
    {
      question: 'Can I play for free?',
      answer: 'Many casinos offer demo modes or free play options for slots and table games. This lets you try games without risking real money. However, you can\'t win real cash in demo mode – it\'s purely for practice and entertainment.',
    },
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-16 md:py-24 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-dark text-center mb-12">
            Frequently Asked Questions
          </h2>
          
          <div className="space-y-4">
            {faqs.map((faq, index) => (
              <div
                key={index}
                className="bg-white rounded-lg shadow-md overflow-hidden transition-all"
              >
                <button
                  onClick={() => toggleFAQ(index)}
                  className="w-full px-6 py-4 flex items-center justify-between text-left hover:bg-gray-50 transition-colors"
                >
                  <span className="font-semibold text-gray-dark pr-4">
                    {faq.question}
                  </span>
                  {openIndex === index ? (
                    <ChevronUp className="text-yellow-accent flex-shrink-0" size={20} />
                  ) : (
                    <ChevronDown className="text-gray-light flex-shrink-0" size={20} />
                  )}
                </button>
                
                {openIndex === index && (
                  <div className="px-6 pb-4">
                    <p className="text-gray-light leading-relaxed">{faq.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;

